var map = {
	"./az.json": [
		4292,
		292
	],
	"./ka.json": [
		6739,
		739
	],
	"./ro.json": [
		364,
		364
	],
	"./ru.json": [
		3206,
		206
	],
	"./tg.json": [
		3530,
		530
	],
	"./uz.json": [
		8072,
		72
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4358;
module.exports = webpackAsyncContext;